module.exports = __webpack_public_path__ + "static/media/x56-logo.f5d27ee6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/X56/x56-logo.svg
// module id = 474
// module chunks = 0